export default __webpack_public_path__ + "static/layer5-kanvas-designer-4c521709f369987eecb50e3072328e9e.webp";